<template>
	<div class="link-radio-group" :class="classes">
		<link-check-all v-if="multiple"
						:color="color"
						:size="size"
						:status="checkAllStatus"
						:disabled="disabled"
						:width="itemWidth"
						@click="p_clickCheckAll"
						@select-all="$emit('select-all')"
						@select-some="$emit('select-some')"
						@select-none="$emit('select-none')"/>
		<slot></slot>
	</div>
</template>

<script>

    import {EditMixin} from "../mixins";
    import LinkCheckAll from "./link-check-all";

    export default {
        name: 'link-radio-group',
        components: {LinkCheckAll},
        mixins: [EditMixin],
        provide() {
            return {
                radioGroup: this,
            }
        },
        props: {
            value: {},

            size: {type: String, default: 'small'},
            color: {},
            activeIcon: {},
            inactiveIcon: {},
            activeColor: {},
            inactiveColor: {},
            itemWidth:{},
            multiple: {type: Boolean},
            vertical: {type: Boolean},

            afterSelect: {type: Function},
        },
        data() {
            return {
                singleValue: this.value,
                multipleValue: LinkUtils.deepCopy(this.value) || [],
                radios: [],
            };
        },
        watch: {
            value(val) {
                if (!!this.multiple) {
                    if (this.multipleValue !== val) this.multipleValue = LinkUtils.deepCopy(val);
                } else {
                    if (this.singleValue !== val) this.singleValue = val;
                }
                this.$nextTick(() => this.updateRadios());
            },
            multipleValue(val) {
                if (JSON.stringify(val) !== JSON.stringify(this.value))
                    this.$emit('input', val);
            },
            singleValue(val) {
                this.$emit('input', val);
            },
        },
        methods: {
            addRadio(radio) {
                this.radios.push(radio);
            },
            removeRadio(radio) {
                LinkUtils.removeFromArray(this.radios, radio);
            },
            updateRadios() {
                this.radios.forEach(async radio => {
                    if (!!this.multiple) {
                        radio.currentValue = LinkUtils.oneOf(radio.val, this.multipleValue || []);
                    } else {
                        radio.currentValue = (radio.val === this.singleValue);
                    }
                });
            },
            async handleChange() {
                await this.$lv.nextTick()
                this.$emit('change', !!this.multiple ? this.multipleValue : this.singleValue)
                !!this.afterSelect && (this.afterSelect(!!this.multiple ? this.multipleValue : this.singleValue))
            },
            p_clickCheckAll() {
                const allVals = this.radios.map(item => item.val)
                switch (this.checkAllStatus) {
                    case 'all':
                        this.multipleValue = []
                        break
                    case 'some':
                        this.multipleValue = allVals
                        break
                    case 'none':
                        this.multipleValue = allVals
                }
                this.updateRadios()
            },
        },
        computed: {
            classes() {
                return [
                    {'link-radio-group-disabled': !!this.lv_disabled},
                    `link-radio-group-${!!this.vertical ? 'vertical' : 'horizontal'}`,
                ];
            },
            checkAllStatus() {
                if (this.radios.every(radio => radio.currentValue)) return 'all'
                if (this.radios.some(radio => radio.currentValue)) return 'some'
                if (this.radios.every(radio => !radio.currentValue)) return 'none'
            },
        },
        mounted() {
            if (!!this.multiple && !!this.value && LinkUtils.typeOf(this.value) !== 'array') {
                console.error('[radio-group] value must be instance of array when multiple is true!');
            }
        },
    };
</script>

<style lang="scss">
	@include themeify {
		.link-radio-group {
			line-height: 28px;
			flex-wrap: wrap;

			&.link-radio-group-disabled {
				.link-radio {
					cursor: not-allowed;
				}
			}
		}
	}
</style>
